export const DEVICE_TYPE_SOURCE = {
    ADM: 'adm',
    AOM: 'aom',
} as const;
